import {
  Ambulance, Wheelchair, PersonSimpleWalk, UsersThree, CreditCard, Buildings,
  ShieldCheck, Clock, HeartHalf, MapPinLine, CheckCircle, Star, Phone, ArrowRight,
  Heart, Handshake, CalendarCheck, ChatCircleText, MapTrifold, FirstAid,
  House, HandHeart, Users, Play,
} from "@phosphor-icons/react";

const MAP = {
  Ambulance, Wheelchair, PersonSimpleWalk, UsersThree, CreditCard, Buildings,
  ShieldCheck, Clock, HeartHalf, MapPinLine, CheckCircle, Star, Phone, ArrowRight,
  Heart, Handshake, CalendarCheck, ChatCircleText, MapTrifold, FirstAid,
  House, HandHeart, Users, Play,
};

export function Icon({ name, ...props }) {
  const Cmp = MAP[name] || FirstAid;
  return <Cmp {...props} />;
}
